import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  CanDeactivate
} from '@angular/router';



@Injectable()
export class checkUrlRoutingGuard implements CanActivate, CanDeactivate<any> {

  public IgonoreRoutes: Array<string> = new Array<string>();
  constructor() {
    this.IgonoreRoutes.push("Welcome");
    this.IgonoreRoutes.push("Policy");
    this.IgonoreRoutes.push("Proposals");
    this.IgonoreRoutes.push("Proposals");
    this.IgonoreRoutes.push("NewReg");
    //this.IgonoreRoutes.push("uploads");

  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

    let currentRoute: string = sessionStorage.getItem("CurrentRoute");
    let index: number = this.IgonoreRoutes.indexOf(currentRoute);
    // alert(currentRoute);
    if (route.url.toString() !== currentRoute) {
      return false;
    }
    else {
      return true;
    }

  }

  canDeactivate(component: any) {
    let browserStatus = sessionStorage.getItem("BackClicked");
    sessionStorage.setItem("BackClicked", "N");
    if (browserStatus == "Y") {
      history.pushState(null, null, location.href);
      return false;
    }
    return true;

  }

}



// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Services/checkUrlRoutingGuard.ts